import axios, {AxiosResponse} from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import {PaginationQuery} from '@/shared/sort/pagination-query.interface';
import {Identifiable} from '@/core/base/interface/identifiable.interface';
import {ErrorStore} from '@/shared/config/store/error.store';
import {getModule} from 'vuex-module-decorators';
import {DataResult} from "@/core/base/type/data-result.type";

export default abstract class DataService<T extends Identifiable> {
    protected abstract baseApiUrl: string;

    protected errorStore: ErrorStore = getModule(ErrorStore);

    public find(id: number): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            axios
                .get(`${this.baseApiUrl}/${id}`)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public retrieve(paginationQuery?: PaginationQuery): Promise<DataResult<T>> {
        return this.retrieveWithUrl(this.baseApiUrl, paginationQuery);
    }

    protected retrieveWithUrl(url: string, paginationQuery?: PaginationQuery): Promise<DataResult<T>> {
        return new Promise<any>((resolve, reject) => {
            axios
                .get(`${url}?${buildPaginationQueryOpts(paginationQuery)}`)
                .then(res => {
                    resolve({
                        data: res.data,
                        totalCount: Number(res.headers['x-total-count']),
                    });
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public delete(id: number): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            axios
                .delete(`${this.baseApiUrl}/${id}`)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public create(entity: T): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            axios
                .post(`${this.baseApiUrl}`, entity)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public update(entity: T): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            axios
                .put(`${this.baseApiUrl}/${entity.id}`, entity)
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public partialUpdate(entity: T): Promise<T> {
        return new Promise<T>((resolve, reject) => {
            axios
                .patch(`${this.baseApiUrl}/${entity.id}`, entity, {
                    headers: {
                        'Content-Type': 'application/merge-patch+json',
                    },
                })
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}
